import React from 'react';
import { useTranslation } from 'react-utilities';
import { TPunishment } from '../../utils/types';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';
import getForeshadowTranslationText from '../../utils/getForeshadowTranslationText';

/**
 * Experimental message to warn users of more severe consequence if they continue violation
 */
const ForeshadowPageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { translate } = useTranslation();
  const { punishmentData } = props;
  const foreshadowType = punishmentData.context?.NEXT_CONSEQUENCE_TYPE;
  const foreshadowDuration = punishmentData.context?.NEXT_CONSEQUENCE_DURATION;
  const foreshadowtext = getForeshadowTranslationText(
    foreshadowType,
    foreshadowDuration,
    translate
  );
  return (
    <div data-testid='foreshadow'>
      <span className='foreshadow-title'>{translate('Foreshadow.Title')} </span>
      <span data-testid='foreshadow-paragraph'>{foreshadowtext}</span>
    </div>
  );
};

const ForeshadowPageItemConfig: NAPageItemConfigType = {
  getIsVisible: (punishmentData: TPunishment) => {
    return !!punishmentData.isForeshadowingConsequenceEnabled;
  },
  renderComponent: ForeshadowPageItem,
  configName: 'foreshadow'
};

export default ForeshadowPageItemConfig;
